import { InstructorApplicationStatus } from "models/enumerations/aen-applications/instructor-application-status";
import { ProviderApplicationStatus } from "models/enumerations/aen-applications/provider-application-status";
import { createContext, useContext } from "react";

export interface ApplicationSearchCriteria {
    searchText: string;
    status: ProviderApplicationStatus | InstructorApplicationStatus | undefined;
    assignedToId: number | undefined;
    hasCompletedInitialSearch: boolean;
    currentPage: number;
}

export interface ApplicationSearchContextParams {
    currentUserId: number | undefined;
    initialCriteria: ApplicationSearchCriteria;
    setCriteria: React.Dispatch<React.SetStateAction<ApplicationSearchCriteria>>;
}

const defaultApplicationSearchCriteria = (currentUserId: number | undefined): ApplicationSearchCriteria => ({
    searchText: "",
    assignedToId: currentUserId,
    status: undefined,
    hasCompletedInitialSearch: false,
    currentPage: 1,
});

const ApplicationSearchContext = createContext<ApplicationSearchContextParams>({
    currentUserId: undefined,
    initialCriteria: defaultApplicationSearchCriteria(undefined),
    setCriteria: () => {}
});

const useApplicationSearch = () => {

    return useContext(ApplicationSearchContext);
};

export { ApplicationSearchContext, useApplicationSearch, defaultApplicationSearchCriteria };
